export type BucketUploadInput = {
	uploadUrl: string;
	file: File;
	contentType?: string;
};

export default {
	/**
	 * Uploads a file to S3 through a presigned PUT URL.
	 *
	 * `fetch` rejects only on network failure, so a 403 from S3 resolves normally.
	 * Without an explicit `response.ok` check a rejected upload reports success, and
	 * the user is told the document was saved when it was not.
	 *
	 * The URL is signed with a specific ContentType, so send back exactly the content
	 * type the server returned instead of letting the browser infer one.
	 */
	async uploadResumeFileToBucketWithFetchAPI(
		inputData: BucketUploadInput,
		successCallBack: (response: Response) => void | Promise<void>,
		errorCallBack: (error: unknown) => void | Promise<void>,
	): Promise<void> {
		let response: Response;

		try {
			response = await fetch(inputData.uploadUrl, {
				method: "PUT",
				body: inputData.file,
				headers: inputData.contentType ? { "Content-Type": inputData.contentType } : undefined,
			});

			if (!response.ok) {
				throw new Error(`Upload failed (${response.status}). Please try again.`);
			}
		} catch (error) {
			return await errorCallBack(error);
		}

		return await successCallBack(response);
	},
};
